import { Box, Text, Title } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import type { ReactNode } from "react";
import { IconButton } from "../../mantine/components/IconButton/IconButton";
import { NoDataMessage } from "../BuildingBlocks/NoDataMessage/NoDataMessage";

interface NoEntriesProps {
  title?: string;
  message?: string;
  customMessage?: ReactNode;
  entryType?: string;
  onClickAddEntry?: () => void;
}

function NoEntries({
  title = "Legen Sie jetzt los!",
  message,
  customMessage,
  entryType = "Eintrag",
  onClickAddEntry
}: NoEntriesProps) {
  const defaultMessage = `Es gibt noch keinen ${entryType} in Ihrer Liste. Klicken Sie unten auf den Button und erstellen Sie Ihren ersten ${entryType}.`;
  const buttonText = `${entryType} hinzufügen`;

  const actionsContent = onClickAddEntry ? (
    <IconButton color="primary" icon={IconPlus} onClick={onClickAddEntry}>
      {buttonText}
    </IconButton>
  ) : null;

  const messageContent = customMessage ? (
    <Text c="neutral" fw={600} p="xl" ta="center">
      {customMessage}
    </Text>
  ) : (
    <NoDataMessage c="neutral" fw={600} message={message || defaultMessage} />
  );

  return (
    <Box p="xl" ta="center">
      <Title fw={600} order={6} size="h3">
        {title}
      </Title>
      {messageContent}
      {actionsContent}
    </Box>
  );
}

export { NoEntries, NoEntriesProps };
